import { Stack } from '@mui/material';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Fade from '@mui/material/Fade';
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import Iconify from 'src/components/iconify';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  borderRadius: '25px',
  boxShadow: 24,
  p: 4,
};

export default function ModalLayout(props) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  // console.log('props', props);
  return (
    <div>
      {props.component ? (
        <Button onClick={handleOpen}>{props.component}</Button>
      ) : props?.treeViews == true ? (
        <Stack direction="row" onClick={handleOpen}>
          <Iconify icon={props.icon} sx={{ mr: 2 }} />
          <Typography variant="subtitle2">{props.title}</Typography>
        </Stack>
      ) : (
        <Button onClick={handleOpen}>{props.title}</Button>
      )}

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={open}>
          <Box sx={style}>
            <Stack direction="row" alignItems="center" justifyContent="space-between" mb={4}>
              <Typography variant="h6" color="initial">
                <span style={{ color: '#ad1f22' }}>{props.description}</span>
              </Typography>
            </Stack>
            <Stack direction="row" spacing={4} marginLeft={10}>
              <Button onClick={props.Hit} variant="contained">
                Yes
              </Button>
              <Button onClick={handleClose} variant="contained">
                No
              </Button>
            </Stack>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}
